import { render, staticRenderFns } from "./managerReview.vue?vue&type=template&id=8c0822b8&scoped=true"
import script from "./managerReview.vue?vue&type=script&lang=js"
export * from "./managerReview.vue?vue&type=script&lang=js"
import style0 from "./managerReview.vue?vue&type=style&index=0&id=8c0822b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0822b8",
  null
  
)

export default component.exports